(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 989px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  (() => {
    const storageKey = 'kgy-cart-form-fields';
    const selector = '.kgy-cart-form-fields__control';

    const readValues = () => {
      try {
        return JSON.parse(sessionStorage.getItem(storageKey)) || {};
      } catch (error) {
        return {};
      }
    };

    const writeValue = (name, value) => {
      const values = readValues();
      values[name] = value;
      sessionStorage.setItem(storageKey, JSON.stringify(values));
    };

    const weekdayLabels = ['日', '月', '火', '水', '木', '金', '土'];
    const pad2 = (n) => String(n).padStart(2, '0');

    // 定休日アプリ(closed-days)の公開エンドポイントから設定を取得（1回だけ・メモ化）。
    // 取得できない場合は null を返し、従来の土日基準ロジックにフォールバックする。
    let closedDaysConfigPromise = null;
    const fetchClosedDaysConfig = (apiUrl) => {
      if (!apiUrl) {
        return Promise.resolve(null);
      }
      if (!closedDaysConfigPromise) {
        closedDaysConfigPromise = fetch(apiUrl, { credentials: 'omit' })
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null);
      }
      return closedDaysConfigPromise;
    };

    // 配送希望日プルダウンを構築する。
    //   config あり : 基準日(本日。定休日なら次の営業日まで送る) から
    //                 定休日・臨時休業日を除外した「営業日」を開始日数ぶん進めた日を開始日とする。
    //                 開始日が決まった後は、そこから表示数ぶんの「連続した暦日」を表示する
    //                （定休日もスキップしない。開始日の算出にのみ営業日換算を使う）。
    //   config なし : 従来動作（土日を考慮した固定オフセット）。
    const populateDeliveryDates = (deliveryDateSelect, config) => {
      const storedDeliveryDate = readValues()['attributes[配送希望日]'];
      const deliveryDatePlaceholder = deliveryDateSelect.dataset.deliveryDatePlaceholder || '';
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      let startDate = new Date(today);
      let deliveryDateCount = 10;

      if (config) {
        const weekdaysClosed = Array.isArray(config.weekdaysClosed) ? config.weekdaysClosed : [];
        const holidays = config.holidays || {};
        const holidaysEnabled = config.holidaysEnabled !== false;
        const customClosedDays = Array.isArray(config.customClosedDays) ? config.customClosedDays : [];
        const openExceptions = Array.isArray(config.openExceptions) ? config.openExceptions : [];
        const closedExceptions = Array.isArray(config.closedExceptions) ? config.closedExceptions : [];
        const offset = Number.isInteger(config.deliveryStartOffsetDays) ? config.deliveryStartOffsetDays : 7;
        deliveryDateCount = Number.isInteger(config.deliveryCount) ? config.deliveryCount : 10;

        const isClosed = (date) => {
          const ymd = `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
          // 特定日の上書きを最優先で判定。
          if (openExceptions.includes(ymd)) {
            return false; // この日は営業日に上書き
          }
          if (closedExceptions.includes(ymd)) {
            return true; // この日は臨時休業に上書き
          }
          if (weekdaysClosed.includes(date.getDay())) {
            return true;
          }
          if (holidaysEnabled && holidays[ymd]) {
            return true;
          }
          const md = `${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
          return customClosedDays.includes(md);
        };

        // 基準日 = 本日。定休日でない最初の日まで進める。
        const base = new Date(today);
        let guard = 0;
        while (isClosed(base) && guard < 366) {
          base.setDate(base.getDate() + 1);
          guard += 1;
        }

        // 基準日から「営業日」を開始日数ぶん進めた日を開始日とする（定休日・臨時休業日はカウントしない）。
        startDate = new Date(base);
        let advanced = 0;
        guard = 0;
        while (advanced < offset && guard < 3660) {
          startDate.setDate(startDate.getDate() + 1);
          guard += 1;
          if (!isClosed(startDate)) {
            advanced += 1;
          }
        }
      } else {
        const deliveryDateStartOffsetDays = 7;
        const todayWeekday = today.getDay();
        if (todayWeekday === 6) {
          startDate.setDate(today.getDate() + 9);
        } else if (todayWeekday === 0) {
          startDate.setDate(today.getDate() + 8);
        } else {
          startDate.setDate(today.getDate() + deliveryDateStartOffsetDays);
        }
      }

      deliveryDateSelect.innerHTML = '';

      const placeholderOption = document.createElement('option');
      placeholderOption.value = '';
      placeholderOption.textContent = deliveryDatePlaceholder;
      deliveryDateSelect.appendChild(placeholderOption);

      for (let index = 0; index < deliveryDateCount; index += 1) {
        const deliveryDate = new Date(startDate);
        deliveryDate.setDate(startDate.getDate() + index);

        const year = deliveryDate.getFullYear();
        const month = pad2(deliveryDate.getMonth() + 1);
        const day = pad2(deliveryDate.getDate());
        const weekday = weekdayLabels[deliveryDate.getDay()];
        const formattedDate = `${year}-${month}-${day}(${weekday})`;

        const option = document.createElement('option');
        option.value = formattedDate;
        option.textContent = formattedDate;

        if (formattedDate === storedDeliveryDate) {
          option.selected = true;
        }

        deliveryDateSelect.appendChild(option);
      }

      if (storedDeliveryDate) {
        deliveryDateSelect.value = storedDeliveryDate;
      }
    };

    const restoreValues = () => {
      const values = readValues();

      const deliveryDateSelect = document.querySelector('[data-cart-delivery-date-select]');
      if (deliveryDateSelect) {
        const apiUrl = deliveryDateSelect.dataset.closedDaysApi || '';
        fetchClosedDaysConfig(apiUrl).then((config) => {
          populateDeliveryDates(deliveryDateSelect, config);
        });
      }

      document.querySelectorAll(selector).forEach((field) => {
        if (field.matches('[data-cart-delivery-date-select]')) {
          return;
        }

        if (values[field.name]) {
          field.value = values[field.name];
        }
      });
    };

    document.addEventListener('change', (event) => {
      if (!event.target.matches(selector)) {
        return;
      }

      writeValue(event.target.name, event.target.value);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, restoreValues);
    }

    document.addEventListener('DOMContentLoaded', restoreValues);
    restoreValues();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  // 注意: このJSブロック内ではLiquidが評価されないため、section.idに依存せず
  // data属性ですべてのポップアップを処理する。
  (() => {
    const setupPopup = (popup) => {
      if (popup.dataset.popupReady === 'true') return;
      popup.dataset.popupReady = 'true';

      const closeButton = popup.querySelector('[data-popup-close]');
      const inner = popup.querySelector('.popup__image-inner');
      const link = popup.querySelector('[data-popup-link]');
      const storageKey = popup.dataset.popupKey;
      const isEditor = window.Shopify && window.Shopify.designMode;

      // 一度閉じたら再表示しない（テーマエディタでは常に表示）
      try {
        if (!isEditor && storageKey && localStorage.getItem(storageKey) === 'hidden') {
          popup.remove();
          return;
        }
      } catch (error) {}

      // エディタでの再描画などで残った同じポップアップの古いコピーを除去
      document.querySelectorAll('[data-popup]').forEach((other) => {
        if (other !== popup && other.dataset.popupKey === storageKey) {
          other.remove();
        }
      });

      // 配置場所に関わらず、スクロールしても画面に追従するフローティング表示にする。
      // body直下へ移動して position:fixed が確実にビューポート基準になるようにする。
      document.body.appendChild(popup);
      popup.classList.add('popup--fixed');

      popup.hidden = false;

      // 表示直後は、開いた操作（ページ遷移時のタップ等）で誤って閉じないようにする
      const openedAt = Date.now();
      let closing = false;

      const persist = () => {
        try {
          if (storageKey) localStorage.setItem(storageKey, 'hidden');
        } catch (error) {}
      };

      const finishClose = () => {
        popup.hidden = true;
        popup.classList.remove('is-closing');
        document.removeEventListener('pointerdown', onOutsideTap, true);
        document.removeEventListener('keydown', onKeydown);
      };

      const closePopup = () => {
        if (closing || popup.hidden) return;
        closing = true;
        persist();

        const prefersReducedMotion =
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion || !inner) {
          finishClose();
          return;
        }

        // 煙のように消えるアニメーション（CSS: popup-smoke）
        popup.classList.add('is-closing');

        let done = false;
        const onEnd = () => {
          if (done) return;
          done = true;
          finishClose();
        };
        inner.addEventListener('animationend', onEnd, { once: true });
        // animationend が発火しない環境向けのフォールバック
        setTimeout(onEnd, 1000);
      };

      // ポップアップ以外（画像の外側）をクリック／タップしたら閉じる。
      // iOS Safari では <div> 等の非インタラクティブ要素をタップしても click が
      // 発火しないため、マウス・タッチ・ペンすべてで確実に発火する pointerdown を使う。
      function onOutsideTap(event) {
        if (popup.hidden || closing) return;
        // 表示直後の誤タップでは閉じない（×ボタンでは常に閉じられる）
        if (Date.now() - openedAt < 600) return;
        if (inner && inner.contains(event.target)) return;
        closePopup();
      }

      function onKeydown(event) {
        if (event.key === 'Escape') closePopup();
      }

      // ×ボタン
      if (closeButton) {
        closeButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          closePopup();
        });
      }

      // リンク付き画像クリック時は遷移を妨げず、閉じた状態として保存
      if (link) {
        link.addEventListener('click', () => {
          persist();
        });
      }

      document.addEventListener('pointerdown', onOutsideTap, true);
      document.addEventListener('keydown', onKeydown);
    };

    const init = (root) => {
      (root || document).querySelectorAll('[data-popup]').forEach(setupPopup);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    // テーマエディタでセクションを追加・編集した直後にも初期化する
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:select', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
